<template>
  <div class="wave-optics-pro-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>sinθ₁ / sinθ₂ = v₁ / v₂$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 渲染区：水波模拟 -->
      <div class="canvas-item simulation">
         <svg width="100%" height="240" viewBox="0 0 400 240">
            <!-- 介质分界面 -->
            <line v-if="mode === 'refraction'" x1="0" y1="120" x2="400" y2="120" stroke="#ffd700" stroke-width="2" stroke-dasharray="8,4" />
            <rect v-else x="0" y="200" width="400" height="40" fill="#34495e" /> <!-- 反射墙 -->

            <!-- 波纹 -->
            <circle v-for="r in ripples" :key="r" cx="200" :cy="rippleSourceY" :r="r" fill="none" :stroke="rippleColor(r)" stroke-width="2" />
         </svg>

         <div class="hud-top">
            <div class="badge">{{ mode === 'refraction' ? '波的折射 (跨介质)' : '波的反射 (遇障碍)' }}</div>
         </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row">
               <div class="col-full center">
                  <el-radio-group v-model="mode" size="mini">
                     <el-radio-button label="reflection">反射模式</el-radio-button>
                     <el-radio-button label="refraction">折射模式</el-radio-button>
                  </el-radio-group>
               </div>
            </div>
            <div class="row">
               <div class="col">
                  <label>波源位置</label>
                  <el-slider v-model="rippleSourceY" :min="10" :max="100" size="mini"></el-slider>
               </div>
            </div>
         </div>

         <div class="discovery-box">
            <p><strong>物理详解：</strong>根据<strong>惠更斯原理</strong>，波面上的每一点都可以看作新的子波源。当波遇到障碍物时会发生<strong>反射</strong>；当波从一种介质进入另一种介质，由于<strong>波速变化</strong>，传播方向会发生偏折，即<strong>折射</strong>。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WaveReflectionViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      mode: 'reflection',
      rippleSourceY: 50,
      ripples: [20, 40, 60, 80],
      t: 0
    }
  },
  methods: {
    rippleColor(r) {
       let opacity = 1 - (r / 200);
       return `rgba(0, 210, 255, ${opacity})`;
    }
  },
  mounted() {
     this.timer = setInterval(() => {
        this.ripples = this.ripples.map(r => (r + 2) % 200);
     }, 30);
  },
  beforeDestroy() { clearInterval(this.timer); }
}
</script>

<style scoped lang="scss">
.wave-optics-pro-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #ffd700; background: rgba(255,215,0,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-item { 
   background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
   .hud-top { position: absolute; top: 15px; left: 15px; .badge { color: #00d2ff; font-size: 0.7rem; border: 1px solid #00d2ff; padding: 2px 8px; border-radius: 4px; } }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; .row { margin-bottom: 10px; &.center { text-align: center; } .col-full { width: 100%; } label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } } }
.discovery-box { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
